@if (message) {
    <div class="numpad-error"><span [innerHtml]="message" (click)="onClick()"> </span></div>
}
